<div class="grid grid-cols-12 gap-8">
    <app-cards-dashboard class="contents" [todayTotal]="todayTotal()" [previousTotal]="previousTotal()"
        [branchesTotal]="branchesTotal()" />

    <div class="col-span-12 xl:col-span-6 flex">
        <div class="card w-full h-full flex flex-col">

            <app-pending-branches-today
                [pendingBranches]="pendingBranchTodayResource.value()?.data ?? []" />

            <div class="mt-auto">
                <app-pagination prefix="today"
                    [totalRecords]="pendingBranchTodayResource.value()?.pagination?.total ?? 0" />
            </div>

        </div>
    </div>

    <div class="col-span-12 xl:col-span-6 flex">
        <div class="card w-full h-full flex flex-col">
            <app-pending-branches-previous-days
                [pendingBranches]="pendingBranchPreviousDayResource.value()?.data ?? []" />

            <div class="mt-auto">
                <app-pagination prefix="previous"
                    [totalRecords]="pendingBranchPreviousDayResource.value()?.pagination?.total ?? 0" />
            </div>
        </div>
    </div>

    <div class="col-span-12 xl:col-span-12 flex">
        <div class="card w-full h-full flex flex-col">
            <app-branches-differences-table
                [pendingBranches]="differencesBranchTodayResource.value()?.data ?? []" />

            <div class="mt-auto">
                <app-pagination prefix="difference"
                    [totalRecords]="differencesBranchTodayResource.value()?.pagination?.total ?? 0" />
            </div>
        </div>
    </div>
</div>
